export const sortByDate = <T extends { created_at: string }>(
  list: T[],
  type: string,
): T[] => {
  if (type === "newest") {
    return [...list].sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
    );
  }
  if (type === "oldest") {
    return [...list].sort(
      (a, b) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
    );
  }
  if (type === "shuffle") {
    return [...list].sort(() => Math.random() - 0.5);
  }
  return list;
};
